import React, { useEffect } from "react";

function Testimonials() {
  useEffect(() => {
    // Initialize Owl Carousel for testimonials
    if (window.$ && window.$.fn.owlCarousel) {
      window.$(".testimonials-one__carousel").owlCarousel({
        loop: true,
        margin: 30,
        nav: false,
        smartSpeed: 500,
        autoHeight: false,
        autoplay: true,
        dots: true,
        autoplayTimeout: 10000,
        navText: [
          '<span class="icon-right-arrow left"></span>',
          '<span class="icon-right-arrow"></span>',
        ],
        responsive: {
          0: { items: 1 },
          600: { items: 1 },
          800: { items: 2 },
          1024: { items: 2 },
          1200: { items: 3 },
        },
      });
    }
  }, []);

  const testimonials = [
    {
      id: 1,
      name: "Mitul Patel",
      title: "",
      image: "",
      text:
        "After working with the team for over 10 years, it's clear they truly understand investment properties. Suhani Builders consistently exceeds expectations, identifying high-ROI opportunities and making every transaction seamless.",
    },
    {
      id: 2,
      name: "Dhara Desai",
      title: "",
      image: "",
      text:
        "Suhani Builders brings deep expertise in both real estate investing and construction. Their attention to detail, quality workmanship, and focus on returns make them a trusted partner on every project.",
    },
    {
      id: 3,
      name: "Dr. Chitrang Parikh",
      title: "",
      image: "",
      text:
        "Suhani Builders truly had our best interests in mind throughout the home-buying process. Their market knowledge, transparency, and attention to detail helped us find the right home with confidence.",
    },
  ];


  return (
    <section className="testimonials-one clearfix" id="testimonial">
      <div className="auto-container">
        <div className="section-title text-center">
          <span className="section-title__tagline">Our Testimonials</span>
          <h2 className="section-title__title">What They Say?</h2>
        </div>

        <div className="row">
          <div className="col-xl-12">
            <div className="testimonials-one__wrapper">
              <div className="testimonials-one__pattern">
                <img
                  src="assets/images/suhani/testimonials-one-left-pattern.png"
                  alt=""
                />
              </div>
              <div className="shape1">
                <img src="assets/images/suhani/thm-shape3.png" alt="" />
              </div>

              <div className="row">
                <div className="col-xl-12">
                  <div className="testimonials-one__carousel owl-carousel owl-theme owl-dot-type1">
                    {testimonials.map((item, index) => (
                      <div
                        key={item.id}
                        className="testimonials-one__single wow fadeInUp"
                        data-wow-delay={`${index * 100}ms`}
                        data-wow-duration="1500ms"
                      >
                        <div className="testimonials-one__single-inner">
                          <p className="testimonials-one__single-text">
                            {item.text}
                          </p>

                          <div className="testimonials-one__single-client-info">
                            {item.image ? (
                              <div className="testimonials-one__single-client-info-img">
                                <img src={item.image} alt={item.name} />
                              </div>
                            ) : null}
                            <div className="testimonials-one__single-client-info-text">
                              <h5>{item.name}</h5>
                              {item.title ? <p>{item.title}</p> : null}
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </section>

  );
}

export default Testimonials;
